import setDocumentData from '../OrganizationDetails/setDocumentData';
import {
  SUBTRACT_SELECT_ALL,
  ADD_SELECT_ALL,
  ADD_ROLES_COUNT,
  SUBTRACT_ROLES_COUNT,
} from '../../../../../../../../../constants/slate/documentOps';

export default (params) => {
  const { setExport, isExported, data, editor, currentRole, roleKey } = params;

  /**
   * Set local state
   */

  setExport(!isExported);

  /**
   * Set role data
   */
  const dataJSON = data.toJSON();
  editor.moveToStartOfNode(currentRole).setNodeByKey(roleKey, {
    data: {
      ...dataJSON,
      toExport: !isExported,
    },
  });

  /**
   * Fetch document data
   */
  const {
    value: { document: currentDocument },
  } = editor;
  const { data: currentDocumentData } = currentDocument;
  let documentRolesCount = currentDocumentData.get('rolesCount');

  /**
   * Fetch organization data
   */
  const organization = currentDocument.getParent(roleKey);
  const { nodes: organizationNodes, data: organizationData } = organization;
  const organizationDataJSON = organizationData.toJSON();
  let { selectAll } = organizationDataJSON;
  const prevSelectAll = selectAll;
  /**
   * Update the respective properties for document and organization
   */
  if (isExported) {
    selectAll -= 1;
    documentRolesCount -= 1;
  } else {
    selectAll += 1;
    documentRolesCount += 1;
  }

  /**
   * Use case: Update select all mark on organization details
   */
  editor.moveToStartOfNode(organization).setNodeByKey(organization.key, {
    data: {
      ...organizationDataJSON,
      selectAll,
    },
  });
  editor.blur();
  /**
   * Use case: Update left pane check mark
   */
  const {
    value: { document: updatedDocument },
  } = editor;

  /**
   * If previous roles are completely selected & we're unchecking one of them, we need to subtract 1 the selectAll of document
   * If previous roles are not completely selected & we're checking one and making completely selected, then we need to add 1 the selectAll of document
   */
  const organizationNodesSize = organizationNodes.size;
  const rolesSize = Math.floor(organizationNodesSize / 2);
  let documentUpdateType;
  if (prevSelectAll === rolesSize) {
    documentUpdateType = SUBTRACT_SELECT_ALL;
  } else if (selectAll === rolesSize) {
    documentUpdateType = ADD_SELECT_ALL;
  } else if (selectAll > prevSelectAll) {
    documentUpdateType = ADD_ROLES_COUNT;
  } else if (selectAll < prevSelectAll) {
    documentUpdateType = SUBTRACT_ROLES_COUNT;
  }

  /**
   * TODO: Make this a util
   */
  setDocumentData({
    selectAllCount: selectAll,
    documentRolesCount,
    type: currentRole.type,
    currentDocument: updatedDocument,
    editor,
    documentUpdateType,
  });
};
